import { FolderContent } from '@/api/generatedApi';
import { BulkDeleteContentModal } from '@/components/modals/BulkDeleteContentModal';
import { BulkLabelModal } from '@/components/modals/BulkLabelModal';
import { BulkMoveContentsModal } from '@/components/modals/BulkMoveContentsModal/BulkMoveContentsModal';
import { BulkReprocessModal } from '@/components/modals/BulkReprocessModal';
import { useBulkDeleteModal } from './useBulkDeleteModal';
import { useBulkLabelModal } from './useBulkLabelModal';
import { useBulkMoveModal } from './useBulkMoveModal';

export const BulkActionModals = <T extends FolderContent>({
  bulkMove,
  bulkDelete,
  bulkReprocess,
  bulkLabel,
}: {
  bulkMove: ReturnType<typeof useBulkMoveModal<T>>;
  bulkDelete: ReturnType<typeof useBulkDeleteModal<T>>;
  bulkReprocess: ReturnType<typeof useBulkDeleteModal<T>>;
  bulkLabel: ReturnType<typeof useBulkLabelModal<T>>;
}) => (
  <>
    <BulkMoveContentsModal
      isOpen={bulkMove.isOpen}
      onClose={bulkMove.close}
      contents={bulkMove.items as FolderContent[]}
      targetFolder={bulkMove.targetFolder}
      selectionMode
      onTargetSelected={bulkMove.setTargetFolder}
      onMoveComplete={bulkMove.handleComplete}
    />
    <BulkDeleteContentModal
      open={bulkDelete.isOpen}
      onClose={bulkDelete.close}
      selectedContent={bulkDelete.items as FolderContent[]}
      onDeleteComplete={bulkDelete.handleComplete}
    />
    <BulkReprocessModal
      open={bulkReprocess.isOpen}
      onClose={bulkReprocess.close}
      selectedContent={bulkReprocess.items as FolderContent[]}
      onReprocessComplete={bulkReprocess.handleComplete}
    />
    <BulkLabelModal
      open={bulkLabel.isOpen}
      onClose={bulkLabel.close}
      selectedContent={bulkLabel.items as FolderContent[]}
      onLabelComplete={bulkLabel.handleComplete}
    />
  </>
);
